import { render, staticRenderFns } from "./report-actions.vue?vue&type=template&id=6b32bf84&"
import script from "./report-actions.vue?vue&type=script&lang=tsx&"
export * from "./report-actions.vue?vue&type=script&lang=tsx&"
import style0 from "./report-actions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports